import api, { apiPrefix } from './Api';
import {
  Address,
  addressFromResponse,
  addressOutputTransformer,
} from '../interfaces/Address/Address';

const addressApiPrefix = `${apiPrefix}/addresses`;

export const createAddress = async (address: Address): Promise<Address> => {
  const response = await api.post(
    addressApiPrefix,
    addressOutputTransformer(address),
  );

  return addressFromResponse(response.data);
};

export const getAddresses = async (): Promise<Address[]> => {
  const response = await api.get(addressApiPrefix);

  return (response.data ?? []).map(addressFromResponse);
};

export const getAddressByID = async (id: number): Promise<Address> => {
  const response = await api.get(`${addressApiPrefix}/${id}`);

  return addressFromResponse(response.data);
};

export const updateAddress = async (address: Address): Promise<Address> => {
  const response = await api.put(
    `${addressApiPrefix}/${address.id}`,
    addressOutputTransformer(address),
  );

  return addressFromResponse(response.data);
};

export const deleteAddress = async (id: number): Promise<void> =>
  api.delete(`${addressApiPrefix}/${id}`);
